'use strict';

var baseApi = require('./base-api.js');

var endpoints = {
	ownerReviewSubmit: 'cars/submit',
	forSale: 'for-sale'
};

function getApiUrl(type, url) {

	if (type) {
		url += '/' + type;
	}

	return url;
}

module.exports = {
	submitOwnerReview: function(data, options) {
		var url = getApiUrl('owner-review', endpoints.ownerReviewSubmit);
		baseApi.post(url, data, options);
	},

	submitDealerContact: function(data, options) {
		var url = getApiUrl('contact-dealer', endpoints.forSale);
		baseApi.post(url, data, options);
	}
};